import "./index.scss"
import SignupButton from "../../layout/button"
import {ReactComponent as Left} from "../../../assets/logos/logo-left.svg"
import {ReactComponent as Right} from "../../../assets/logos/logo-right.svg"
import Charts from "../charts"
import React, { useState, useEffect } from 'react';
import {motion} from "framer-motion"


const data = [
  {id:"l1", name:"Unlock Potential"},
  {id:"l2", name:"Enhance Productivity"},
  {id:"l3", name:"Enhance Efficiency"},
  {id:"l4", name:"Enhance Excellence"},
  {id:"l5", name:"Enhance Performance"},
]


const Bussiness = () => {

    const [scrollPosition, setScrollPosition] = useState(0);
    const [list, setList] = useState(data)

    useEffect(() => {
        const interval = setInterval(() => {

          setScrollPosition(prevPosition => prevPosition - 30);
          setList(prevList => [prevList[1], prevList[2], prevList[3], prevList[4], prevList[0]])
        }, 2000);
    
        return () => clearInterval(interval);
      }, []);

    return(
        <div className="position-relative bg-col-container-bg d-flex flex-column justify-content-center align-items-center w-100">
            <div className="d-flex flex-row justify-content-center align-items-center align-self-center pt-50 pb-50 res">
                <motion.div initial={{opacity:0}} animate={{opacity:1, transition:{duration:1, type:"tween", ease:"easeInOut"}}} className="w-55 mt-4 first">
                    <motion.div className="col-quaternary font-weight-5 text-12 m-b-8 text-uppercase cent">#NextGeneration #HRMS #HCM #Payroll #AllinOne</motion.div>
                    <motion.h2 className="col-container-font m-b-5 hide-mb h1-size">Empowering Business,</motion.h2>
                    <motion.h2 className="col-container-font m-b-5 show-mb h1-size">Empowering</motion.h2>
                    <motion.h2 className="col-container-font mb-0 flow hide-mb h1-size"> Enriching Lives: <span style={{ transform: `translateY(${scrollPosition}px)`}} className="col-secondary scrolling-text">{list[0].name}</span></motion.h2>
                    <motion.h2 className="col-container-font mb-0 flow show-mb h1-size"> Bussiness, Enriching Lives:</motion.h2>
                    <motion.h2 className="col-container-font mb-0 flow show-mb h1-size mt-1"><span style={{ transform: `translateY(${scrollPosition}px)`}} className="col-secondary scrolling-text">{list[0].name}</span></motion.h2>
                    <motion.p className="font font-weight-3 m-t-16 m-b-30 p-size">
                        Enjoy a seamless journey from recruitment to retirement, backed by unparalleled user experience, robust architecture, flexible and affordable pricing.
                    </motion.p>
                    <motion.div className="res-btn">
                      <SignupButton />
                    </motion.div>
                </motion.div>
                <div className="d-flex flex-column justify-content-center align-items-center position-relative w-45 second">
                  <Charts />
                  <div className="position-absolute bgnd z-index-0 rounded-circle">
                  </div>
                </div>
            </div>
        <Left className="position-absolute  right-0  top-8 p-0" />
        <Right className="position-absolute left-0 bottom-0 p-0 ev"  />
    </div>    
    )
}

export default Bussiness
